export default __webpack_public_path__ + "static/microsoft_365_logo-ce0d3b855f7bfd9676b154bdd25b1396.webp";